import { hasBoardPagePermission } from '../authStorage';
import { useT } from '../i18n/translations';

export default function MemberPagePermissionGuard({ moduleId, children }) {
  const t = useT();
  if (!hasBoardPagePermission(moduleId)) {
    return (
      <div style={{ padding: 28, fontFamily: 'Cairo, sans-serif', color: '#78909c' }}>
        {t('common.noPerm')}
      </div>
    );
  }
  return children;
}
